import { timelineWidgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseTimelineWidgetsArg = {
  programId: string;
};

export function useTimelineWidgets({ programId }: UseTimelineWidgetsArg) {
  const widgets = useSelectedFieldStore(
    timelineWidgetStore,
    () => timelineWidgetStore.get()[programId]?.widgets
  );
  return widgets;
}
